import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Card, CardContent, IconButton, Stack, Typography} from 'views/components';
import {Edit as EditIcon} from 'views/icons';
import {MarkdownEditor, MarkdownViewer, Translate, translate} from 'views/module';

const FamilyNote = (props) => {
  const {expression, value, save, reload} = props;
  const progressWrap = props.statusProgressWrap;

  const [editing, setEditing] = React.useState(false);
  const [draft, setDraft] = React.useState('');
  const [saving, setSaving] = React.useState(false);

  const openDialog = () => {
    setDraft(value ?? '');
    setEditing(true);
  };

  const closeDialog = () => setEditing(false);

  const submit = async () => {
    setSaving(true);
    await progressWrap(async () => {
      await save(draft.trim() ? draft : null);
      setEditing(false);
      reload();
    }, {
      onErrorMessage: () => translate('family.FamilyMembers.Notes.Error'),
      debugString: 'FAMILY_NOTE_SAVE',
    });
    setSaving(false);
  };

  return (
    <>
      <Card
        variant='outlined'
        sx={{
          height: '100%',
          borderRadius: '12px',
          borderColor: '#E8E4DE',
        }}
      >
        <CardContent>
          <Stack spacing={1}>
            <Stack direction='row' sx={{alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography sx={{fontWeight: 600}}>
                <Translate expression={`${expression}.Title`} />
              </Typography>
              <IconButton
                size='small'
                aria-label={translate(`${expression}.EditTitle`)}
                onClick={openDialog}
              >
                <EditIcon fontSize='small' />
              </IconButton>
            </Stack>
            {
              value ? (
                <MarkdownViewer value={value} truncate truncateLine={8} />
              ) : (
                <Typography sx={{fontSize: '14px', color: 'text.secondary'}}>
                  <Translate expression={`${expression}.Empty`} />
                </Typography>
              )
            }
          </Stack>
        </CardContent>
      </Card>
      {
        editing &&
        <Dialog maxWidth='md' onClose={closeDialog}>
          <DialogTitle onClose={closeDialog}>
            <Translate expression={`${expression}.EditTitle`} />
          </DialogTitle>
          <DialogContent>
            <MarkdownEditor value={draft} onChange={setDraft} height={320} autoFocus />
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={closeDialog}>
              <Translate expression='family.FamilyMembers.Cancel' />
            </Button>
            <Button disabled={saving} onClick={submit}>
              <Translate expression='family.FamilyMembers.Save' />
            </Button>
          </DialogActions>
        </Dialog>
      }
    </>
  );
};

FamilyNote.propTypes = {
  expression: PropTypes.string.isRequired,
  value: PropTypes.string,
  save: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(FamilyNote));
